<template>
    <div>
        <div v-if="options_loaded && passed_filter">
            <template v-if="filtered_option_list.length > 0 && filtered_option_list[0].value !== null">
                <div class="designeroption" :data-designer-component-id="component_id">
                    <h3>{{ title }}</h3>
                    <div class="designer-floating-sidebar-message" v-if="floating_sidebar_message">
                        <i class="fa fa-circle-question"></i>
                        <span v-html="floating_sidebar_message"></span>
                    </div>
                    <div class="stylesoption selectoption form-group">
                        <select :id="'question--' + component_id" class="form-control" v-model="localTarget" v-if="!loading">
                            <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
                        </select>
                        <select :id="'question--' + component_id" disabled class="form-control" v-if="loading">
                            <option>Loading Options...</option>
                        </select>
                      <div v-if="extra_text !== ''" v-html="extra_text" class="mt-3"></div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionTechnicalThreshold from "../DesignerQuestionTechnicalThreshold.vue";

    export default {
        mixins: [
            DesignerQuestionTechnicalThreshold
        ],
        props: {
            component_id: {
                default(){
                    return 'threshold';
                }
            },
            extra_text: {
              default(){
                return '';
              }
            },
        },
    }
</script>
